/**
 * ResultadoContagemReport - Inline display for Resultado da Contagem (SINAI format)
 *
 * 13 Columns: Grupo, Produto, Descrição, Lote, Validade, Faixa Aging,
 *             Sistema, Contado, Sobras, Faltas, Coletado, Faturar, Pacientes
 */
import React from 'react';
import { RelatorioGeraisTable } from '../../relatorios-gerais/RelatorioGeraisTable';
import type { Column } from '../../relatorios-gerais/RelatorioGeraisTable';

interface Props {
  data: any[];
  loading: boolean;
  meta: any;
}

const columns: Column[] = [
  { key: 'grupo', label: 'Grupo', width: '130px' },
  { key: 'produto', label: 'Produto', width: '130px' },
  { key: 'descricao', label: 'Descrição', width: '220px' },
  { key: 'lote', label: 'Lote', width: '140px' },
  { key: 'validade', label: 'Validade', width: '90px' },
  { key: 'faixa_aging', label: 'Faixa Aging', width: '140px' },
  { key: 'sistema', label: 'Sistema', align: 'right', format: 'number', width: '70px' },
  { key: 'contado', label: 'Contado', align: 'right', format: 'number', width: '70px' },
  { key: 'sobras', label: 'Sobras', align: 'right', format: 'number', width: '70px' },
  { key: 'faltas', label: 'Faltas', align: 'right', format: 'number', width: '70px' },
  { key: 'coletado', label: 'Coletado', width: '70px' },
  { key: 'faturar', label: 'Faturar', width: '70px' },
  { key: 'pacientes', label: 'Pacientes', width: '70px' },
];

export const ResultadoContagemReport: React.FC<Props> = ({ data, loading, meta }) => {
  return (
    <div className="space-y-3">
      {meta && (
        <div className="text-sm text-gray-600 dark:text-gray-400">
          <span className="font-medium">{meta.hospital}</span>
          {meta.cliente && (
            <span className="ml-3">Cliente: {meta.cliente}</span>
          )}
          {meta.data_contagem && (
            <span className="ml-3">Data da contagem: {meta.data_contagem}</span>
          )}
          {meta.total_items != null && (
            <span className="ml-3">{meta.total_items} itens</span>
          )}
        </div>
      )}
      <RelatorioGeraisTable
        columns={columns}
        data={data}
        loading={loading}
        showTotals
        emptyMessage="Nenhum item encontrado para esta contagem."
        highlightRow={(row) => {
          // Story 2.63: faltas agora é positivo (igual à aba Dados da Contagem)
          const faltas = Number(row.faltas || 0);
          const sobras = Number(row.sobras || 0);
          if (faltas > 0) return 'bg-red-50 dark:bg-red-900/10';
          if (sobras > 0) return 'bg-green-50 dark:bg-green-900/10';
          return '';
        }}
      />
    </div>
  );
};
